<template>
  <div class="risk">
    <!-- Первая строка grid -->
    <img
      src="/img/capital/warning.svg"
      alt="warning"
    >
    <div class="title">
      {{ $t("auCapitals.risk.keyRisk") }}
    </div>
    <AuIcon
      :icon="isFullSize ? 'chevron_up' : 'chevron_down'"
      clickable
      @click="isFullSize = !isFullSize"
    />
    <!-- Вторая строка grid -->
    <div />
    <div v-if="isFullSize">
      <div class="title mt-2">
        1. {{ $t("auCapitals.risk.marketRisk") }}
      </div>
      <div class="text">
        {{ $t("auCapitals.risk.marketText") }}
      </div>
      <div class="title mt-2">
        2. {{ $t("auCapitals.risk.liquidityRisk") }}
      </div>
      <div class="text">
        {{ $t("auCapitals.risk.liquidityText") }}
      </div>
      <div class="title mt-2">
        3. {{ $t("auCapitals.risk.tenantRisk") }}
      </div>
      <div class="text">
        {{ $t("auCapitals.risk.tenantText") }}
      </div>
      <div class="title mt-2">
        4. {{ $t("auCapitals.risk.regulatoryRisk") }}
      </div>
      <div class="text">
        {{ $t("auCapitals.risk.regulatoryText") }}
      </div>
      <div class="separator" />
    </div>
    <div
      v-else
      class="subheader"
    >
      {{ $t("auCapitals.risk.moreView") }}
    </div>
    <div />
    <!-- Третья строка grid -->
    <img
      v-if="isFullSize"
      src="/img/capital/warning.svg"
      alt="warning"
    >
    <div
      v-if="isFullSize"
      class="title"
    >
      {{ $t("auCapitals.risk.propertyRisk") }}
    </div>
    <div v-if="isFullSize" />
    <!-- Четвертая строка grid -->
    <div v-if="isFullSize" />
    <div v-if="isFullSize">
      <div
        v-for="(risk, i) in props.risks"
        :key="i"
      >
        <div class="title mt-2">
          {{ (i+1) + ". " + risk.caption }}
        </div>
        <div class="text">
          {{ risk.description }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import AuIcon from "@/components/extended/AuIcon.vue";
import { ref } from "vue";

const isFullSize = ref(false);
const props = defineProps({
  risks: {
    type: Array,
    default: () => []
  }
});
</script>

<style scoped lang="scss">
.risk {
  width: 100%;
  border: 2px solid #D14040;
  border-radius: 12px;

  padding: 18px 33px;
  display: grid;
  grid-template-columns: 55px auto 20px;
  align-items: center;

  .title {
    font-weight: 500;
    font-size: 16px;
  }

  .text {
    padding-left: 20px;
    font-weight: 400;
    color: var(--color-40);
  }

  .subheader {
    color: var(--color-60);
  }

  .separator {
    width: 100%;
    height: 1px;
    border: 1px solid #D14040;
    margin-top: 28px;
    margin-bottom: 28px;
  }
}
</style>